"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const app_component_1 = require("./app.component");
const vasat_1 = require("vasat");
class LoginNeeded {
    constructor(V, r) {
        this.V = V;
        this.r = r;
    }
    canActivate(route, state) {
        if (this.V.localSession())
            return true;
        else {
            this.r.navigate(['/auth'], { queryParams: { prevpage: state.url, msg: 'Login Timed out' } });
            return false;
        }
    }
}
exports.LoginNeeded = LoginNeeded;
const ɵ0 = () => Promise.resolve().then(() => require("./project/index.ngfactory")).then(m => m.ProjectMapModuleNgFactory), ɵ1 = () => Promise.resolve().then(() => require("./files/index.ngfactory")).then(m => m.FileModuleNgFactory);
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
const Routes = [
    { path: ':team', component: app_component_1.AppBaseComponent,
        children: [
            { path: '', component: app_component_1.HomeComponent },
            { path: 'project', loadChildren: ɵ0 },
            { path: 'files', loadChildren: ɵ1 }
        ]
    }
];
class Ver2Module {
}
exports.Ver2Module = Ver2Module;
